import { InternalResource } from '@interfaces/InternalResource';

export class InternalResourceVM {
  internalResource: InternalResource;
  isSelected: boolean;
  code: string;

  //used when an internal resource was added to the estimate
  //and then the estimate got filters applied to it.
  isNotInActiveFilters: boolean;

  public constructor() {
    this.internalResource = <InternalResource>{};
    this.isSelected = false;
  }

  setInternalResourceVM(internalResource: InternalResource, isSelected = false) {
    if (!internalResource) return;

    this.internalResource = internalResource;
    this.isSelected = isSelected;
  }
}
